import {validate as validateEmail} from "email-validator"
import links from "./links";
import paymentProviders from "./paymentProviders";

let environment = process.env.REACT_APP_ENVIRONMENT || 'development'
let country = process.env.REACT_APP_COUNTRY || 'ch';
let currency = country === "ch" ? "CHF" : "EUR";
let routerBasename = process.env.REACT_APP_ROUTERBASENAME || '';
let minimalCartValue = country === "ch" ? 40 : 30;
let cartVersion = 2; // used to validate the adventure (i.e. cart) object ... if the structure changes, we need to change this version

const displayActivityImages = {
  development:false,
  staging:true,
  production:true
}

const site = {
  development: {
    url: country === "ch" ? "http://localhost:3001" : "http://localhost:3011",
    urlByCountry: {
      ch: "http://localhost:3001",
      de: "http://localhost:3011"
    } 
  },
  staging: {
    url: country === "ch" ? "https://shop-staging.appentura.ch" : "https://shop-staging.appentura.de",
    urlByCountry: {
      ch: "https://shop-staging.appentura.ch",
      de: "https://shop-staging.appentura.de"
    } 
  },
  production: {
    url: country === "ch" ? "https://shop.appentura.ch" : "https://shop.appentura.de",
    urlByCountry: {
      ch: "https://shop.appentura.ch",
      de: "https://shop.appentura.de"
    } 
  }
}

const api = {
  development: {
    root: `http://${window.location.hostname}:8090/v1/shop3`
  },
  staging: {
    root: 'https://api-staging.appentura.io/v1/shop3',
  }
  ,
  production: {
    root: 'https://api.appentura.io/v1/shop3',
  }
}
const ticket = {
  development: {
    url: `http://${window.location.hostname}:8090/v1/certificate`
  },
  staging: {
    url: 'https://api-staging.appentura.io/v1/certificate',
  }
  ,
  production: {
    url: 'https://api.appentura.io/v1/certificate',
  }
}

const stripe = {
  development: {
    key: 'pk_test_mcia4UdMnF7lEyNQBb4YJ3Cr'
  },
  staging: {
    key: 'pk_test_mcia4UdMnF7lEyNQBb4YJ3Cr'
  },
  production: {
    key: 'pk_live_vpgvH7KqqT0k638hyhUZOBdB'
  }
}

const hotjar = {
  development: {
    hjid:1450610,
    hjsv:6
  },
  staging: {
    hjid:1451289,
    hjsv:6
  },
  production: {
    hjid:1451041,
    hjsv:6
  }
}
const checkoutSteps = [
  {key:'cart', index:0, title:'Warenkorb'},
  {key:'packaging', index:1, title:'Verpackung'},
  {key:'personalize', index:2, title:'Personalierung'},
  {key:'payment', index:3, title:'Bezahlung'},
  {key:'confirm', index:4, title:'Bestätigung'}
]

const localStorageKeys = {
  purchases:'as3-purchases',
  adventure:'as3-adventure',
  adventureTime:'as3-adventureTime',
  favourites:'as3-favourites',
  checkoutProgress:'as3-checkoutProgress',
  cookies:'as3-cookies-accepted-on',
  buddy:'as3-buddy'
}

const layout = {
  sidebarPosition:"right"
}

const personalizeFields = [
  {
    field:"Occasion",
    label:"Anlass",
    allowCustom:true,
    customPlaceholder: "bitte einen Anlass angeben",
    kind: "dropdown",
    options: [
      {label:"bitte wählen ...", value: ""},
      {label:"Geburtstag", value: "Geburtstag"},
      {label:"Weihnachten", value: "Weihnachten"},
      {label:"Hochzeit", value: "Hochzeit"},
      {label:"Mitarbeitergeschenk", value: "Mitarbeitergeschenk"},
      {label:"Jahrestag", value: "Jahrestag"},
      {label:"Danke", value: "Danke"},
      {label:"einfach so", value: "einfach so"}
    ],
    help:"Sag uns, zu welchem Anlass du die Überraschung verschenkst."
  },
  {
    field:"ParticipantName",
    label:"Für wen ist das Geschenk",
    mandatory:true,
    help:`Dieser Text wird auf den Gutschein gedruckt. Zum Beispiel "Mario & Luigi", "Käthi" ... oder ein Kosename, denn "Knudeli" ist doch viel persönlicher als "René" ... ;)`,
    maxLength:50,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"Bitte gib an, für wen das Geschenk ist"}
    }
  },
  {
    field:"SenderName",
    label:"Von wem ist das Geschenk",
    mandatory:true,
    help:`Dieser Text wird auf den Gutschein gedruckt. Zum Beispiel "Trudi", "Schatz", "Mami & Papi" oder "FC Fischermätteli"`,
    maxLength:50,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"gib an, vom wem das Geschenk ist"}
    }
  },
  {
    field:"Comments",
    label:"Persönliche Nachricht", 
    mandatory:false,
    help:`Du kannst dem Beschenkten auf dem Gutschein eine Nachricht hinterlassen. Gratuliere zum Fest oder lass deinen Gefühlen freien Lauf ...`,
    maxLength:140,
    multiline:true
  },
  {
    field:"OrderComments",
    label:"Bemerkungen an Appentura",
    mandatory:false,
    help:`Hier kannst du uns mitteilen worauf wir bei der Organisation achten sollten. Zum Beispiel Allergien, Ängste, Essgewohnheiten oder was Du sonst noch für wichtig empfindest.`,
    maxLength:null,
    multiline:true
  }
]

const paymentFields = [
  {
    field:"ClientFirstName",
    label:"Vorname",
    mandatory:true,
    autocomplete:"billing given-name",
    help:null,
    maxLength:null,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"Bitte Vorname für Rechnungsadresse angeben"}
    }
  },
  {
    field:"ClientName",
    label:"Nachname",
    mandatory:true,
    autocomplete:"billing family-name",
    help:null,
    maxLength:null,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"Bitte Nachname für Rechnungsadresse eingeben"}
    }
  },
  {
    field:"ClientCompany",
    label:"Firma",
    mandatory:false,
    autocomplete:"billing organization",
    help:null,
    maxLength:null,
    validate:null
  },
  {
    field:"ClientAddress",
    label:"Adresse",
    mandatory:true,
    autocomplete:"billing address-line1",
    help:null,
    maxLength:null,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"Bitte Adresse (Strasse und Nr) für Rechnungsadresse eingeben"}
    }
  },
  {
    field:"ClientAddress2",
    label:"Adresse Zusatz",
    mandatory:false,
    autocomplete:"billing address-line2",
    help:null,
    maxLength:null,
    validate:null
  },
  {
    field:"ClientZip",
    label:"PLZ",
    mandatory:true,
    autocomplete:"billing postal-code",
    help:null,
    maxLength:null,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"Bitte PLZ für Rechnungsadresse eingeben"}
    }
  },
  {
    field:"ClientCity",
    label:"Ort",
    mandatory:true,
    autocomplete:"billing address-level2",
    help:null,
    maxLength:null,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"Bitte Ort für Rechnungsadresse eingeben"}
    }
  },
  /* currently user cannot select
  {
    field:"ClientCountry",
    label:"Land",
    allowCustom:false,
    kind: "dropdown",
    options: [
      {label:"Schweiz", value: "CH"},
      {label:"Deutschland", value: "DE"}
    ],
    help:null
  },
  */
  {
    field:"ClientEmail",
    label:"E-Mail",
    mandatory:true,
    autocomplete:"billing email",
    help:null,
    maxLength:null,
    validate:(t) => {
      let valid = validateEmail(t.trim())
      return {valid, text:"Bitte eine gültige E-Mail Adresse eingeben"}
    }
  }
]

const shippingFields = [
  {
    field:"ShippingFirstName",
    label:"Vorname",
    mandatory:true,
    autocomplete:"shipping given-name",
    help:null,
    maxLength:null,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"Bitte Vorname für Lieferadresse angeben"}
    }
  },
  {
    field:"ShippingName",
    label:"Nachname",
    mandatory:true,
    autocomplete:"shipping family-name",
    help:null,
    maxLength:null,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"Bitte Nachname für Lieferadresse eingeben"}
    }
  },
  {
    field:"ShippingCompany",
    label:"Firma",
    mandatory:false,
    autocomplete:"shipping organization",
    help:null,
    maxLength:null,
    validate:null
  },
  {
    field:"ShippingAddress",
    label:"Adresse",
    mandatory:true,
    autocomplete:"shipping address-line1",
    help:null,
    maxLength:null,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"Bitte Adresse (Strasse und Nr) für Lieferadresse eingeben"}
    }
  },
  {
    field:"ShippingAddress2",
    label:"Adresse Zusatz",
    mandatory:false,
    autocomplete:"shipping address-line2",
    help:null,
    maxLength:null,
    validate:null
  },
  {
    field:"ShippingZip",
    label:"PLZ",
    mandatory:true,
    autocomplete:"shipping postal-code",
    help:null,
    maxLength:null,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"Bitte PLZ für Lieferadresse eingeben"}
    }
  },
  {
    field:"ShippingCity",
    label:"Ort",
    mandatory:true,
    autocomplete:"shipping address-level2",
    help:null,
    maxLength:null,
    validate:(t) => {
      let valid = t.trim().length > 0
      return {valid, text:"Bitte Ort für Lieferadresse eingeben"}
    }
  },
  /* currently user cannot select
  {
    field:"ShippingCountry",
    label:"Land",
    allowCustom:false,
    kind: "dropdown",
    options: [
      {label:"Schweiz", value: "CH"},
      {label:"Deutschland", value: "DE"}
    ],
    help:null
  }
  */
]

const standardBenefits = [
  {
    key:"scavengerhunt",
    text:"Überraschung mit Smartphone-Anweisungen",
    info:{
      title:"Überraschung mit Smartphone-Anweisungen",
      text:"Für den Beschenkten bleibt geheim, was Du gewählt hast. Er wählt ein Datum und Startort und wird auf dem Smartphone Schritt für Schritt durch seine Überraschung geführt - ein unvergessliches Erlebnis!"
    }
  },
  {
    key:"organisation",
    text:"Planung & Organisation im Vorfeld",
    info: {
      title:"Planung & Organisation im Vorfeld",
      text:"Wir planen den passenden Ablauf und tätigen die Buchung der Aktivitäten. Während der Überraschung steht dem Beschenkten bei Fragen unsere Hotline zur Verfügung."
    }
  }
]

// payment types. possible values are: stripe, payrexx, transfer
// the first value is default
const paymentTypes = {
  ch:["transfer", "payrexx"], 
  de:["payrexx"]
}

export default {
  environment,
  country, 
  cartVersion,
  currency,
  routerBasename,
  minimalCartValue,
  displayActivityImages:displayActivityImages[environment], // just for development purposes
  site:site[environment],
  api:api[environment],
  hotjar:hotjar[environment],
  stripe:stripe[environment],
  ticket:ticket[environment],
  localStorageKeys:localStorageKeys,
  checkoutSteps:checkoutSteps,
  layout,
  personalizeFields,
  paymentFields,
  shippingFields,
  standardBenefits,
  links,
  paymentProviders:paymentProviders[country],
  paymentTypes
}
